/* Doodle Dreams: begin fetching remaining page images after the first paint.
   Actual network/download timing remains subject to device and connection speed. */
(() => {
  if (window.__ddImagesAhead) return;
  window.__ddImagesAhead = true;
  function warmPageImages() {
    const pending = Array.from(document.querySelectorAll('img[loading="lazy"]'));
    if (!pending.length) return;
    // Prioritize media closest to the current viewport, then warm the remainder.
    pending.sort((a, b) => Math.abs(a.getBoundingClientRect().top) - Math.abs(b.getBoundingClientRect().top));
    let index = 0;
    const batch = () => {
      const end = Math.min(index + 5, pending.length);
      while (index < end) {
        const img = pending[index++];
        if (!img.isConnected || img.complete) continue;
        if (!img.hasAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'low');
        img.loading = 'eager';
        img.decoding = 'async';
      }
      if (index < pending.length) {
        if ('requestIdleCallback' in window) window.requestIdleCallback(batch, {timeout: 900});
        else window.setTimeout(batch, 180);
      }
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(batch, {timeout: 800});
    else window.setTimeout(batch, 160);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', warmPageImages, {once:true});
  else warmPageImages();
})();
